import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  OWNER,
  ADMIN,
  METRICS,
  READONLY,
  OR_ADMIN,
  OR_READONLY,
  OR_SUPERUSER,
  OR_SUPERREAD,
} from 'constants/roles';
import roleDisabled from 'services/roleDisabled/index';
import { selectors, actionCreators } from 'dux/instances';
import ORSpaceUsage from './ORSpaceUsage';

const propTypes = {
  instanceId: PropTypes.string.isRequired,
  getSpaceUsage: PropTypes.func.isRequired,
  spaceUsage: PropTypes.shape({}),
  instanceIsReady: PropTypes.bool.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const defaultProps = {
  spaceUsage: {},
};

const allowedAccess = [
  OWNER,
  ADMIN,
  METRICS,
  READONLY,
  OR_ADMIN,
  OR_READONLY,
  OR_SUPERUSER,
  OR_SUPERREAD,
];

class ORSpaceUsageContainer extends React.Component {
  componentDidMount() {
    const { instanceId, getSpaceUsage, instanceIsReady, userRoles } = this.props;
    if (instanceIsReady && !roleDisabled(userRoles, allowedAccess)) {
      getSpaceUsage(instanceId);
    }
  }

  render() {
    return <ORSpaceUsage {...this.props} />;
  }
}

ORSpaceUsageContainer.propTypes = propTypes;
ORSpaceUsageContainer.defaultProps = defaultProps;

function mapStateToProps(state, ownProps) {
  const { instanceId } = ownProps;
  return {
    spaceUsage: selectors.getInstanceSpaceUsage(state)(instanceId),
    instanceService: selectors.instanceServiceSelector(state, ownProps),
  };
}

const mapDispatchToProps = {
  getSpaceUsage: actionCreators.getSpaceUsage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ORSpaceUsageContainer);
